import { useMemo } from 'react'
import { NotificationPopupProps, Notification } from './NotificationPopup.types'
import { useFilterPeriod } from 'store/notifications/notifications.store'

export const useNotificationPopupLogic = ({
  notifications = [],
}: NotificationPopupProps) => {
  const filterPeriod = useFilterPeriod()

  const hasNotifications = useMemo(() => {
    return notifications.length > 0
  }, [notifications])

  const formatDate = (date: Date) => {
    const today = new Date()
    const yesterday = new Date(today)
    yesterday.setDate(yesterday.getDate() - 1)

    if (date.toDateString() === today.toDateString()) {
      return 'Today'
    } else if (date.toDateString() === yesterday.toDateString()) {
      return 'Yesterday'
    } else {
      return date.toLocaleDateString('en-US', {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
      })
    }
  }

  const groupNotificationsByDate = (notifications: Notification[]) => {
    const groups: { [key: string]: Notification[] } = {}

    notifications.forEach((notification) => {
      if (!notification.timestamp) return

      const dateKey = new Date(notification.timestamp).toDateString()
      if (!groups[dateKey]) {
        groups[dateKey] = []
      }
      groups[dateKey].push(notification)
    })

    // Sort dates in descending order
    return Object.entries(groups)
      .sort(
        ([dateA], [dateB]) =>
          new Date(dateB).getTime() - new Date(dateA).getTime()
      )
      .map(([date, notifications]) => ({
        date: new Date(date),
        notifications,
      }))
  }

  return {
    filterPeriod,
    hasNotifications,
    formatDate,
    groupNotificationsByDate,
  }
}
